/**
 *
 * @template T
 * @param {T[]} array
 * @param {function(T, number, array): boolean} predicate
 * @returns {T | undefined}
 */
export function find(array, predicate) {
  for (let i = 0; i < array.length; i++) {
    if (predicate(array[i], i, array)) {
      return array[i];
    }
  }

  return undefined;
}
